import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PrescriptionListItem {
  id: string;
  prescriptionId: string;
  createdAt: string;
  prescriptionDate: string;
  status: string;
  doctorName: string;
  caseId: string;
  patientId: string;
}

export interface PrescriptionListResponse {
  prescriptions: PrescriptionListItem[];
  totalCount: number;
  hasPrescriptions: boolean;
}

export interface PrescriptionDetails {
  success: boolean;
  data: {
    userDetails: any;
    prescription: any;
    symptoms: string[];
    appointmentDetails: any;
    doctorDetails: any;
  };
  message: string;
}

interface PrescriptionState {
  prescriptionList: PrescriptionListItem[] | null;
  prescriptionDetails: PrescriptionDetails | null;
  selectedPrescriptionId: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: PrescriptionState = {
  prescriptionList: null,
  prescriptionDetails: null,
  selectedPrescriptionId: null,
  loading: false,
  error: null,
};

const prescriptionSlice = createSlice({
  name: 'prescription',
  initialState,
  reducers: {
    setPrescriptionList: (state, action: PayloadAction<PrescriptionListItem[] | null>) => {
      state.prescriptionList = action.payload;
    },
    setPrescriptionDetails: (state, action: PayloadAction<PrescriptionDetails | null>) => {
      state.prescriptionDetails = action.payload;
    },
    setSelectedPrescriptionId: (state, action: PayloadAction<string | null>) => {
      state.selectedPrescriptionId = action.payload;
    },
    setPrescriptionLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPrescriptionError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearPrescriptionData: (state) => {
      state.prescriptionList = null;
      state.prescriptionDetails = null;
      state.selectedPrescriptionId = null;
      state.error = null;
    },
  },
});

export const {
  setPrescriptionList,
  setPrescriptionDetails,
  setSelectedPrescriptionId,
  setPrescriptionLoading,
  setPrescriptionError,
  clearPrescriptionData,
} = prescriptionSlice.actions;

export default prescriptionSlice.reducer;
